/**
 * The valid values for a free busy type for a calendar item
 */
export type CalendarItemType = 'Single' | 'Occurrence' | 'Exception' | 'RecurringMaster';

/**
 * Constants to use for comparing to the CalendarItemType
 */
let CalendarItemTypeConstants = {
    Single: 'Single',
    Occurrence: 'Occurrence',
    Exception: 'Exception',
    RecurringMaster: 'RecurringMaster',
};
export default CalendarItemTypeConstants;
